<!-- ----------------------------------------------- -->
<template>
  <v-col class="administrator pa-0">
    <div class="ad-card-list">
      <div class="ad-scroll pb-2">
        <v-card
          v-for="(link, linkIdx) in linkList"
          :key="'link' + linkIdx"
          class="com-pc-card"
        >
          <v-row class="com-pc-card-header">
            <span class="com-pc-card-title">{{ link.title }}</span>
          </v-row>
          <v-col class="com-pc-card-contents pa-0">
            <v-list>
              <div
                v-for="(item, itemIdx) in link.links"
                :key="'item' + linkIdx + itemIdx"
              >
                <v-divider v-if="itemIdx > 0"></v-divider>
                <v-list-item
                  @click="onLink(item.url, item.gamenId, item.param)"
                >
                  <v-list-item-avatar size="28" class="mt-0 mb-0">
                    <v-img :src="item.img"></v-img>
                  </v-list-item-avatar>
                  <v-list-item-content class="pa-0">
                    <v-list-item-title v-text="item.name"></v-list-item-title>
                  </v-list-item-content>
                  <v-list-item-icon class="mt-3 mb-0">
                    <v-icon color="success">link</v-icon>
                  </v-list-item-icon>
                </v-list-item>
              </div>
            </v-list>
          </v-col>
        </v-card>
      </div>
    </div>
  </v-col>
</template>
<!-- ----------------------------------------------- -->
<script>
/**
 * 川の防災情報 PC用管理者画面
 * Administrator.vue
 * @author LIS
 */
import mixin from "../../../lib/mixin.js";

export default {
  mixins: [mixin],
  computed: {
    baseUrl: {
      get() {
        let url = this.$store.state.app.referrer;
        if (url != null && url != "") {
          url = url.split("/")[0] + "//" + url.split("/")[2];
        }
        this.$log.debug("[Admin]referrer:" + url);
        if (
          (url == null || url == "") &&
          this.appConfig != null &&
          this.appConfig.administratorConfig != null &&
          this.appConfig.administratorConfig.baseUrl != null
        ) {
          url = this.appConfig.administratorConfig.baseUrl;
        }
        return url;
      },
    },
    linkList: {
      get() {
        let list = [];
        if (
          this.appConfig != null &&
          this.appConfig.administratorConfig != null &&
          this.appConfig.administratorConfig.linkList != null
        ) {
          list = this.appConfig.administratorConfig.linkList;
        }
        return list;
      },
    },
    appConfig: {
      get() {
        return this.$store.state.app.config;
      },
    },
    mapConfig: {
      get() {
        return this.$store.state.map.mapConfig;
      },
    },
  },
  mounted() {
    this.checkMode();
    this.$store.commit("app/setContent", "Administrator");
  },
  updated() {
    this.checkMode();
  },
  methods: {
    onLink(url, gId, param) {
      let href = this.baseUrl + url + "?" + "gamenId=" + gId;

      if (param != null && param != "") {
        href = href + "&" + param;
      }

      let areaCd = this.$store.state.map.areaCode;
      if (areaCd == null || areaCd == 0) {
        areaCd = this.mapConfig.nationwideCode;
      }
      href = href + "&areaCd=" + areaCd;

      window.open(href, "_blank");
    },
    checkMode() {
      if (global.KWB_MODE === "admin") {
        if (this.appConfig != null) {
          // 管理者モードが無効の場合はHome画面へ遷移する
          if (
            this.appConfig.administratorConfig == null ||
            this.appConfig.administratorConfig.enable == null ||
            !this.appConfig.administratorConfig.enable
          ) {
            this.routerPcHome();
          }
        }
      } else {
        this.routerPcHome();
      }
    },
  },
  watch: {
    appConfig() {
      this.checkMode();
    },
  },
};
</script>
<!-- ----------------------------------------------- -->
<style lang="scss" scoped>
.administrator {
  height: 100%;
  .ad-card-list {
    position: relative;
    height: 100%;
  }
  .ad-scroll {
    position: absolute;
    height: 100%;
    overflow: auto;
    top: 0px;
    left: 0px;
    right: 0px;
    bottom: 0px;
    & > :not(:first-child) {
      margin-top: 16px;
    }
  }
}
</style>
